import { Component, Input } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Constant } from "src/app/shared/Constants/constant";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-contents",
  templateUrl: "./contents.component.html",
  styleUrls: ["./contents.component.css"],
})
export class ContentsComponent {
  @Input() item = "";
  HeadingText: any;
  ContentText: string = "";
  RouteText: string = "";
  logoPath!: string;
  constructor(private route: ActivatedRoute, private router: Router) {
    this.route.paramMap.subscribe(params => {
      let typeParam = params.get('type') || '';
      this.setHeadingTextFromParam(typeParam);
      this.RouteText = this.HeadingText || this.determineRouteText();
      this.setHeadingTextFromParam(this.RouteText.toLowerCase());
      this.setContentText();
    });
    this.logoPath = environment.ClientLogo;

  }

  private determineRouteText(): string {
    const url = this.router.url;
    if (url.includes("ResetPassword")) {
      return "ResetPassword";
    } else if (url.includes("ForgotPassword")) {
      return "ForgotPassword";
    }
    return "";
  }

  setHeadingTextFromParam(type: string): void {
    this.HeadingText = Constant.ROUTE_PARAM_HEADINGS[type as keyof typeof Constant.ROUTE_PARAM_HEADINGS] || '';
  }

  private setContentText() {
    switch (this.RouteText) {
      case "ResetPassword":
      case "ForgotPassword":
      case "Job Seeker":
      case "Client":
      case "Supplier":
      case "Admin":
        this.ContentText = `
          <p>Welcome to the Inclusive Supplier Diversity Program (ISDP)
, our ISDP is dedicated to empowering diverse suppliers by creating opportunities for innovation, 
collaboration, and growth. Whether you're a <b>minority-owned</b>, <b>women-owned</b>, <b>veteran-owned</b>,<b> LGBTQ+-owned</b>, or <b>disability-owned business</b>, we welcome you to be part of our mission to drive inclusivity and equity in the supply chain.
</p>
<p>
<b>Why Join ISDP?</b><br/>

Access to exclusive partnership opportunities
Resources to grow and scale your business
A network of like-minded suppliers and industry leaders
Join us in creating a more inclusive and equitable marketplace!</p>
         `;
        break;
      default:
        // Handle the default case if needed
        break;
    }
  }
}
